import * as React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { imgPath } from '../../../../common/utils/ImgUrl';
import { DataSource } from '../../../models/SearchResultTypes';
import { FeatureFlag, FeatureFlagService } from '../../../services/FeatureFlagService';
import { ListViewStyles } from '../ListViewStyles';
import { IconComponentProps } from './LinkCell';
import { cssClass } from '../../../../common/styles/CommonStyles';
import { NestedCSSProperties } from 'typestyle/lib/types';

const DatasourceIcons = {
  extract_embedded: {
    list: 'datasource_extract_embedded_18px-large.svg',
    tooltip: 'datasource_extract_embedded_16px_medium.svg',
    masthead: 'datasource_extract embedded_80px_empty.svg',
    card: 'datasource_extract_embedded_60px-card.svg',
  },
  embedded: {
    list: 'datasource_embedded_18px-large.svg',
    tooltip: 'spaces_medium_ds_embedded.svg',
    masthead: 'spaces_masthead_ds_embedded.svg',
    card: 'spaces_card_ds_embedded.svg',
  },
  extract: {
    list: 'datasource_extract_18px-large.svg',
    tooltip: 'spaces_medium_extract.svg',
    masthead: 'spaces_masthead_extract.svg',
    card: 'spaces_card_extract.svg',
  },
  extract_certified: {
    list: 'datasource_extract_certified_18px-large.svg',
    tooltip: 'spaces_medium_extract_certified.svg',
    masthead: 'spaces_masthead_extract_certified.svg',
    card: 'spaces_card_extract_certified.svg',
  },
  live: {
    list: 'datasource_18px-large.svg',
    tooltip: 'spaces_medium_ds.svg',
    masthead: 'spaces_card_ds.svg', // this doesn't look good left-aligned in masthead so use the centered one
    card: 'spaces_card_ds.svg',
  },
  live_certified: {
    list: 'datasource_certified_18px-large.svg',
    tooltip: 'spaces_medium_ds_certified.svg',
    masthead: 'spaces_masthead_ds_certified.svg',
    card: 'spaces_card_ds_certified.svg',
  },
};

export function DataSourceType(props: IconComponentProps): JSX.Element {
  const data = props.data as DataSource;
  const icon = (
    <img
      src={getIconForDatasourceType(data)}
      alt={contentTypeTitleForIconForRow(data)}
      title={contentTypeTitleForIconForRow(data)}
      style={ListViewStyles.listViewIconStyle}
    />
  );
  return (
    <div className={ListViewStyles.ContentTypeCellContainer} style={{ width: '18px' }}>
      {icon}
    </div>
  );

  function getIconForDatasourceType(dataSource: DataSource): string {
    // there are 3 cases need show extract_embedded icon
    // 1) ebmedded ds with extract to file
    // 2) ebmedded ds with extract to published ds with live/extract
    if (dataSource.workbookId && dataSource.hasExtracts) {
      return imgPath(DatasourceIcons.extract_embedded.list);
    }

    if (dataSource.workbookId) {
      return imgPath(DatasourceIcons.embedded.list);
    }

    return getIconPathforPublished(dataSource.hasExtracts || false, isCertified(dataSource));
  }

  function getIconPathforPublished(hasExtracts: boolean, isCertified: boolean): string {
    if (hasExtracts) {
      return imgPath(DatasourceIcons.extract.list);
    } else {
      return imgPath(DatasourceIcons.live.list);
    }
  }

  function contentTypeTitleForIconForRow(data: DataSource): string {
    if (data.workbookId) {
      return Messages.column_datasource_icon_title_emb_ds({
        LIVE_OR_EXTRACT: data.hasExtracts ? Messages.extract() : Messages.live(),
        UNICODE: String.fromCharCode(8212),
      });
    }
    return Messages.datasource();
  }

  function isCertified(dataSource: DataSource): boolean {
    if (FeatureFlagService.instance.getValue(FeatureFlag.datasourceCertificationEnabled) && dataSource.certificationDetails) {
      return dataSource.certificationDetails.isCertified;
    }
    return false;
  }
}

export const GreyedOutTextStyle: React.CSSProperties = {
  color: '#BFBFBF',
  fontWeight: 'inherit',
};

export namespace HiddenUserStyles {
  export const HiddenUserStyle: React.CSSProperties = {
    ...GreyedOutTextStyle,
  };

  export const HiddenUserClassName: string = cssClass('hidden-user', HiddenUserStyle as NestedCSSProperties);
}
